/*
  Cart drawer / cart page extras (snippets/tt-cart-suggest.liquid and snippets/tt-cart-assurance.liquid):
  - "Complete the corner" suggestions: colour select swaps the variant, image and price; "Add" puts the item
    in the cart (lanterns and mattress covers carry "_addon_for" = the teepee's product id) and re-renders the
    cart in place through window.ttCartAddons (assets/tt-cart-addons.js).
  - Estimated delivery window from the dispatch/transit numbers in the markup (working days skip Sundays).
  - Child's birthday (optional) saved as the cart attribute "Child's birthday".
  Everything is delegated from document, so it keeps working after the cart HTML is replaced.
*/
(function () {
	const BDAY_KEY = "Child's birthday";

	function addWorkingDays(date, days) {
		const d = new Date(date);
		let left = days;
		while (left > 0) {
			d.setDate(d.getDate() + 1);
			if (d.getDay() !== 0) left -= 1;
		}
		return d;
	}

	function fmt(d) {
		return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
	}

	// "25–29 Oct", or "30 Oct – 3 Nov" across months.
	function range(from, to) {
		if (from.getMonth() === to.getMonth()) return `${from.getDate()}–${fmt(to)}`;
		return `${fmt(from)} – ${fmt(to)}`;
	}

	function fillDelivery(root) {
		(root || document).querySelectorAll('[data-tt-delivery]:not([data-filled])').forEach((el) => {
			const dispatch = parseInt(el.dataset.dispatch, 10) || 3;
			const min = parseInt(el.dataset.min, 10) || 2;
			const max = parseInt(el.dataset.max, 10) || 6;
			const shipped = addWorkingDays(new Date(), dispatch);
			const from = new Date(shipped);
			from.setDate(from.getDate() + min);
			const to = new Date(shipped);
			to.setDate(to.getDate() + max);
			el.innerHTML =
				el.dataset.format === 'short'
					? `delivery by <strong>${range(from, to)}</strong>`
					: `Dispatched within ${dispatch} working days · <strong>delivery by ${range(from, to)}</strong>`;
			el.dataset.filled = 'true';
		});
	}

	function onSelect(select) {
		const item = select.closest('.tt-cs__item');
		const option = select.selectedOptions[0];
		if (!item || !option) return;
		const button = item.querySelector('[data-tt-cs-add]');
		if (button) button.dataset.variantId = option.value;
		const price = item.querySelector('[data-tt-cs-price]');
		if (price && option.dataset.price) {
			// The money filter output is wrapped by the CVC Multi Currency app (<span class=cvc-money>…</span>).
			// Keep that wrapper so the app can still convert it; anything else is inserted as plain text.
			const html = option.dataset.price.trim();
			if (/^(<span class=["']?cvc-money["']?>[^<]*<\/span>|[^<]*)$/.test(html)) price.innerHTML = html;
			else {
				const tmp = document.createElement('template');
				tmp.innerHTML = html;
				price.textContent = tmp.content.textContent.trim();
			}
		}
		const img = item.querySelector('[data-tt-cs-img]');
		if (img && option.dataset.img) {
			img.removeAttribute('srcset');
			img.src = option.dataset.img;
		}
	}

	async function add(button) {
		if (button.disabled) return;
		const helper = window.ttCartAddons;
		const ui = helper ? helper.cartUi() : null;
		const sections = ui && typeof ui.getSectionsToRender === 'function' ? ui.getSectionsToRender() : [];
		const item = { id: Number(button.dataset.variantId), quantity: 1 };
		if (button.dataset.addonFor) item.properties = { _addon_for: button.dataset.addonFor };

		button.disabled = true;
		button.classList.add('loading');
		try {
			const response = await fetch(`${window.routes.cart_add_url}.js`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
				body: JSON.stringify({
					items: [item],
					sections: sections.map((section) => section.section),
					sections_url: window.location.pathname,
				}),
			});
			const state = await response.json();
			if (!response.ok || state.status) throw new Error(state.description || state.message || 'Could not add to cart');
			if (ui && helper) helper.render(ui, state, sections);
			fillDelivery();
		} catch (error) {
			console.error('[tt-cart-suggest]', error);
			button.disabled = false;
			button.classList.remove('loading');
			const label = button.querySelector('.tt-cs__add-label');
			if (label) label.textContent = 'Try again';
		}
	}

	let bdayTimer;
	function saveBirthday(input) {
		clearTimeout(bdayTimer);
		const status = input.closest('.tt-bday')?.querySelector('[data-tt-bday-status]');
		bdayTimer = setTimeout(async () => {
			try {
				await fetch(`${window.routes.cart_update_url}.js`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
					body: JSON.stringify({ attributes: { [BDAY_KEY]: input.value } }),
				});
				if (status) status.textContent = input.value ? 'Saved' : '';
			} catch (error) {
				console.error('[tt-cart-suggest] birthday', error);
			}
		}, 300);
	}

	// Capture phase: these controls live inside <cart-items>/<cart-drawer-items>, whose own change handler would
	// otherwise read them as a quantity change. Stop the event here, before it reaches the cart.
	document.addEventListener(
		'change',
		(event) => {
			const select = event.target.closest('[data-tt-cs-select]');
			const bday = event.target.closest('[data-tt-bday]');
			if (!select && !bday) return;
			event.stopPropagation();
			if (select) onSelect(select);
			if (bday) saveBirthday(bday);
		},
		true
	);

	document.addEventListener('click', (event) => {
		const button = event.target.closest('[data-tt-cs-add]');
		if (button) {
			event.preventDefault();
			add(button);
		}
	});

	// The cart drawer and cart page swap their HTML after every change; fill new delivery lines as they appear.
	const start = () => {
		fillDelivery();
		let queued = false;
		new MutationObserver(() => {
			if (queued) return;
			queued = true;
			requestAnimationFrame(() => {
				queued = false;
				fillDelivery();
			});
		}).observe(document.body, { childList: true, subtree: true });
	};
	if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
	else start();
})();
